module.exports = __webpack_public_path__ + "img/shop.4985017b.jpg";